import styled from 'styled-components';

export const Container = styled.div.attrs({
  className: 'content'
})``;

export const ModalContainer = styled(Container)`
  justify-content: space-between;
  align-items: center;
  button {
    width: 100%;
    margin: 10px 0;
  }

  input {
    margin-bottom: 20px;
    width: 100%;
    padding: 10px;
    outline: none;
    color: #333 !important;
    font-size: 14px;
    font-weight: 400;
    border: 1px solid #CA3D42;
    border-radius: 5px;

    &:disabled {
      color: #707070;
      background-color: #fff;
    }
  }
`;



export const OutlinedInputContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 12px 0 24px;

  input {
    width: 50px;
    height: 50px;
    font-size: 24px;

    text-align: center;
    border: none;
    border-bottom: 2px solid #ccc;
    margin: 0 8px;
  }
`

export const ErrorText = styled.span`
  color: #dc3545;
  font-size: 12px;
  display: block;
  margin-bottom: 16px;
`;
